import React from 'react';
import { ItineraryTypes } from '../types';
import { StayBadge } from 'ui/StayBadge/StayBadge';
import { VerticalSpace } from 'ui/VerticalSpace';
import { ItemNotesAndAttachments } from './ItemNotesAndAttachments';
import { ItemMedia } from './ItemMedia';
import { SeeMoreCollapsible } from 'ui/SeeMoreCollapsible';

export interface iDestinationMarkerProps {
  item: ItineraryTypes['ItineraryItem'];
  countryName: string;
  regions: string[];
}

export const DestinationMarker = (props: iDestinationMarkerProps) => {
  const { item, countryName, regions } = props;

  const description = item.ancillary_description;

  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-2 mb-10px gap-5px">
        <h2 className="m-0 font-hurmegeometric-sans uppercase text-flint font-bold text-sm">Destination</h2>
        <div className="hidden md:block">{/* deliberately blank */}</div>
        <span className="font-hurmegeometric-sans text-sm uppercase text-flint">{item.region!}</span>
        <StayBadge className="md:justify-self-end" startDate={item.date!} endDate={item.endDate!} hideNights={true} />
      </div>

      {/* then media */}
      <ItemMedia
        uploads={item.uploads as ItineraryTypes['ItineraryImageUploadOrThumbnail'][]}
        titleForModal={item.title}
      />

      <SeeMoreCollapsible cutoffHeightPx={100}>
        {description && (
          <span className="font-hurmegeometric-sans text-14px text-flint leading-22px">{description}</span>
        )}
      </SeeMoreCollapsible>

      {(item.notes.length > 0 || item.uploads.length > 0) && (
        <>
          <VerticalSpace height="10px" />
          <ItemNotesAndAttachments notes={item.notes} uploads={item.uploads} />
          <VerticalSpace height="40px" />
        </>
      )}

      {item.notes.length === 0 && item.uploads.length === 0 && (
        <>
          <VerticalSpace height="40px" />
        </>
      )}
    </div>
  );
};
